/* @flow */

import React, { useContext, useState, useEffect } from "react";
import { useTranslate } from "@awardit/react-use-translate";
import { useHistory, useLocation } from "react-router-dom";
import { StoreInfoContext } from "entrypoint/shared";
import { Helmet } from "react-helmet-async";
import Wrapper from "components/Wrapper";
import RedeemCard from "components/RedeemCard";
import PopularBrands from "components/PopularBrands";
import HowToRedeem from "components/HowToRedeem";
import { QuoteData } from "data";
import { useData, useSendMessage } from "crustate/react";
import { addMessage } from "@crossroads/shop-state/messages";
import { Redirect } from "react-router";
import useSessionStorage from "helpers/use-session-storage";
import { parseParams } from "helpers/location-search-string";
import { formatMeta } from "helpers/get-meta";

import styles from "./styles.scss";

const howToRedeemLocales = new Set(["sv_SE", "da_DK", "nb_NO", "fi_FI"]);

const RedeemView = (): React$Node => {
  const t = useTranslate();
  const quoteData = useData(QuoteData);
  const sendMessage = useSendMessage();
  const { search } = useLocation();
  const { returnUrl: returnUrlParam } = parseParams(search);
  const returnUrl = typeof returnUrlParam === "string" ? returnUrlParam : t("REDEEM.SUCCESS_ROUTE");
  const [alreadyActivedValidation, setAlreadyActivedValidation] = useState<?boolean>(null);

  useEffect(() => {
    if (quoteData.state === "LOADED" && alreadyActivedValidation === null) {
      setAlreadyActivedValidation(Boolean(quoteData.data.retain24validation));
    }
  }, [quoteData.state]);

  if (alreadyActivedValidation === true) {
    sendMessage(addMessage("success", "success"));
    return <Redirect to={returnUrl} />;
  }

  return <RedeemViewReal returnUrl={returnUrl} />;
};

const RedeemViewReal = ({ returnUrl }: { returnUrl: string }) => {
  const { info } = useContext(StoreInfoContext);
  const t = useTranslate();
  const location = useLocation();
  const { push } = useHistory();
  const sendMessage = useSendMessage();
  const [isolationMode] = useSessionStorage("navIsolationMode", "false");
  const navIsolationMode = isolationMode === "true";

  const onSuccess = () => {
    sendMessage(addMessage("success", "success"));
    push(returnUrl);
  };

  const title = t("REDEEM.HEADING");
  const text = t("REDEEM.TEXT");

  const meta = formatMeta({
    title,
    description: text,
    canonicals: [{ rel: "canonical", href: info.baseUrl + location.pathname.split("/")[1] }],
  });

  return (
    <div className={styles.block}>
      <Helmet
        title={meta.title}
        meta={meta.data}
        link={meta.link}
      />
      <Wrapper variant="thin">
        <h1>{title}</h1>
        <p>{text}</p>

        <RedeemCard className={styles.card} onSuccess={onSuccess} />

      </Wrapper>

      {!navIsolationMode &&
        <Wrapper>
          {howToRedeemLocales.has(info.locale) &&
            <HowToRedeem locale={info.locale} />
          }
          <PopularBrands />
        </Wrapper>
      }
    </div>
  );
};

export default RedeemView;
